import React, { Fragment, useCallback, useEffect, useRef } from 'react';
import { observer } from 'mobx-react-lite';
import classNames from 'classnames';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import isNumber from 'lodash/isNumber';
import Item from './Item';
import Animate from '../animate';
import { arrayMove } from '../data-set/utils';
import { PictureProvider } from '../picture/PictureContext';
const AttachmentList = function AttachmentList(props) {
    const { prefixCls, attachments, onUpload, onRemove, onOrderChange, listType, pictureWidth, bucketName, bucketDirectory, storageCode, attachmentUUID, uploadButton, sortable, readOnly, onFetchAttachments, onAttachmentsChange, limit, onHistory, onPreview, previewTarget, isPublic, record, showSize, } = props;
    const isCard = listType === 'picture-card';
    const classString = classNames(prefixCls, isCard ? `${prefixCls}-card` : `${prefixCls}-no-card`);
    const oldValues = useRef();
    const handleDragEnd = useCallback((result) => {
        const { destination, source } = result;
        if (destination && attachments) {
            const newAttachments = attachments.slice();
            arrayMove(newAttachments, source.index, destination.index);
            onOrderChange({ attachments: newAttachments });
        }
    }, [attachments, onOrderChange]);
    useEffect(() => {
        if (attachmentUUID) {
            const { current } = oldValues;
            if (!current || current.attachmentUUID !== attachmentUUID || current.record !== record) {
                if (attachments) {
                    onAttachmentsChange(undefined);
                }
                oldValues.current = { attachmentUUID, record };
                onFetchAttachments({ bucketName, bucketDirectory, storageCode, attachmentUUID, isPublic });
            }
        }
    }, [onFetchAttachments, bucketName, bucketDirectory, storageCode, attachmentUUID, isPublic, record]);
    if (attachments) {
        const { length } = attachments;
        const draggable = sortable && !readOnly && length > 1;
        let previewIndex = 0;
        const list = attachments.map((attachment, index) => {
            const { type, uid } = attachment;
            const restCount = index + 1 === limit ? length - limit : undefined;
            const hidden = isNumber(limit) && index >= limit;
            const itemDraggable = draggable && !restCount;
            const itemIndex = type.startsWith('image') ? previewIndex++ : undefined;
            return (React.createElement(Draggable, { draggableId: uid, index: index, key: uid, isDragDisabled: !itemDraggable }, (provided) => (React.createElement(Item, { key: uid, provided: provided, prefixCls: `${prefixCls}-item`, attachment: attachment, pictureWidth: pictureWidth, listType: listType, bucketName: bucketName, bucketDirectory: bucketDirectory, storageCode: storageCode, showSize: showSize, attachmentUUID: attachmentUUID, onRemove: onRemove, onUpload: onUpload, isCard: isCard, readOnly: readOnly, restCount: restCount, draggable: itemDraggable, index: itemIndex, hidden: hidden, onHistory: onHistory, onPreview: onPreview, previewTarget: previewTarget, isPublic: isPublic }))));
        });
        return (React.createElement(PictureProvider, null,
            React.createElement(DragDropContext, { onDragEnd: handleDragEnd },
                React.createElement(Droppable, { droppableId: "list", key: "list", isDropDisabled: !draggable, direction: isCard ? 'horizontal' : 'vertical' }, (droppableProvided) => (React.createElement("div", Object.assign({ ref: droppableProvided.innerRef }, droppableProvided.droppableProps, { className: classString }),
                    React.createElement(Animate, { component: Fragment, transitionName: "fade", exclusive: true }, list),
                    droppableProvided.placeholder,
                    uploadButton))))));
    }
    if (uploadButton) {
        return (React.createElement("div", { className: classString }, uploadButton));
    }
    return null;
};
AttachmentList.displayName = 'AttachmentList';
export default observer(AttachmentList);
